export function BrandIcon() {
  return <img src="/app-icon.svg?v=1.3.1" alt="" aria-hidden="true" />;
}
